var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 23.5H23.5C17.0375 23.5 11.8087 28.7875 11.8087 35.25L11.75 105.75C11.75 112.213 17.0375 117.5 23.5 117.5H117.5C123.963 117.5 129.25 112.213 129.25 105.75V35.25C129.25 28.7875 123.963 23.5 117.5 23.5ZM115.15 48.4688L73.6137 74.4362C71.7337 75.6113 69.2663 75.6113 67.3863 74.4362L25.85 48.4688C25.2609 48.1381 24.745 47.6913 24.3336 47.1554C23.9222 46.6196 23.6237 46.0058 23.4564 45.3513C23.289 44.6968 23.2562 44.0151 23.3599 43.3476C23.4636 42.68 23.7017 42.0404 24.0598 41.4675C24.4178 40.8946 24.8884 40.4004 25.443 40.0146C25.9976 39.6288 26.6247 39.3596 27.2864 39.2233C27.9481 39.0869 28.6305 39.0862 29.2925 39.2212C29.9544 39.3562 30.5821 39.6241 31.1375 40.0087L70.5 64.625L109.863 40.0087C110.418 39.6241 111.046 39.3562 111.708 39.2212C112.369 39.0862 113.052 39.0869 113.714 39.2233C114.375 39.3596 115.002 39.6288 115.557 40.0146C116.112 40.4004 116.582 40.8946 116.94 41.4675C117.298 42.0404 117.536 42.68 117.64 43.3476C117.744 44.0151 117.711 44.6968 117.544 45.3513C117.376 46.0058 117.078 46.6196 116.666 47.1554C116.255 47.6913 115.739 48.1381 115.15 48.4688Z",
    fill: "#6d7177"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.5 105C129.5 110.2 127.167 113.167 126 114L70.5 76.6957L129 40.5C129 59.6667 129.5 99.8 129.5 105Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.beb02f6a85646ea0e9fec5135e066397.svg";
export { ForwardRef as ReactComponent };